/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Create_UserInputs */

const en_create_user = /** @type {(inputs: Create_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create User`)
};

const de_create_user = /** @type {(inputs: Create_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzer anlegen`)
};

/**
* | output |
* | --- |
* | "Create User" |
*
* @param {Create_UserInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const create_user = /** @type {((inputs?: Create_UserInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Create_UserInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_create_user(inputs)
	return en_create_user(inputs)
});